// src/hooks/useFavicon.js

import { useEffect } from 'react';

interface UseFaviconOptions {
    href: string | null | undefined;
}

const useFavicon = (href: UseFaviconOptions['href']): void => {
    useEffect(() => {
        // Jika tidak ada href yang diberikan, jangan lakukan apa-apa
        if (!href) {
            return;
        }

        // Cari elemen link untuk favicon yang sudah ada
        let link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");

        // Jika tidak ada, buat elemen link baru dan tambahkan ke head
        if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.getElementsByTagName('head')[0].appendChild(link);
        }

        // Setel atribut href ke URL ikon yang baru
        link.href = href;

    }, [href]); // Jalankan efek ini setiap kali 'href' berubah
};

export default useFavicon;